// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorCaseDocumentRelationshipModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorCaseDocumentRelationshipModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorCaseDocumentRelationshipModel.discriminator = undefined;
EnterpriseCoordinatorCaseDocumentRelationshipModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "comment",
        "baseName": "comment",
        "type": "string"
    }
];
//# sourceMappingURL=enterpriseCoordinatorCaseDocumentRelationshipModel.js.map